/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  VzzYJk: 'Create',
  'navigation.universal-create.menuItemLoading': 'Menu item is loading',
  'platform.navigation-experiences.universal-create.remote-section-heading': 'Suggestions',
  'platform.navigation-experiences.universal-create.show-less': 'Less',
  'platform.navigation-experiences.universal-create.show-more': 'More',
};
